var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBurnout = function SvgBurnout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 10C2.5 9.44772 2.94772 9 3.5 9H25.5C26.0523 9 26.5 9.44772 26.5 10V12H28.5C29.6046 12 30.5 12.8954 30.5 14V18C30.5 19.1046 29.6046 20 28.5 20H26.5V22C26.5 22.5523 26.0523 23 25.5 23H3.5C2.94772 23 2.5 22.5523 2.5 22V10ZM26.5 18V14H28.5V18H26.5ZM24.5 11V13V19V21H4.5V11H24.5ZM6.5 12C5.94772 12 5.5 12.4477 5.5 13V19C5.5 19.5523 5.94772 20 6.5 20H10.5C11.0523 20 11.5 19.5523 11.5 19V13C11.5 12.4477 11.0523 12 10.5 12H6.5Z",
    fill: "#1D386C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBurnout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/burnout.f300a14f.svg";
export { ForwardRef as ReactComponent };